export function getInsertionSortAnimations(array)  {
    const animations = [];
    insertionSort(array, animations);

    return animations;
}

function insertionSort(array, animations) {
    let i = 1;
    while (i < array.length) {
        animations.push(['target', i, 'on'])
        const shiftAnimations = [];
        const x = array[i];
        let j = i - 1;
        while (j >= 0 && array[j] > x) {
            animations.push(['position', j, 'on']);
            animations.push(['position', j, 'off']);
            shiftAnimations.push(['shift', j + 1, array[j]]);
            array[j + 1] = array[j];
            j--;
        }
        // revert target color before shifting array
        animations.push(['target', i, 'off']);
        // push shift animations to main animations
        while(shiftAnimations.length !== 0){
            animations.push(shiftAnimations.shift());
        }
        array[j+1] = x;
        animations.push(['shift', j + 1, x]);
        i++;
    }
}